export default __webpack_public_path__ + "static/media/bg.57f7f7c7.svg";